import LeadFormData from '../../LeadsComponents/LeadFormData';
import LeadCallsLog from '../../LeadsComponents/LeadCallsLog';
import LeadActionButtons from '../../LeadsComponents/LeadActionButtons';
import LeadCallsButtons from '../../LeadsComponents/LeadCallsButtons';
import useLeadsStore from '../../../../store/LeadsStore'
import toaster from '../../../../utils/toaster'
import i18next from 'i18next';
import useModalStore from '../../../../store/ModalStore';
import LeadsNotifications from '../../LeadsComponents/LeadsReminders';
import { LeadCreateRequestDTO } from '../../../../api/models/Leads/LeadCreateRequestDTO';
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { TabsEnum } from '../../../../api/models/Enums';
import { useApiClient } from '../../../../hooks/useApiClient';
import { useMemo } from 'react';

import { useErrorToast } from "../../../../hooks/useErrorToast";
import { validationsLeadEditForm } from '../../Validations/validationsLeadForm';
import '../../../../pages/Leads/LeadsPage.scss';

const LeadDetails = () => {
  const { apiClient } = useApiClient();
  const queryClient = useQueryClient();
  const { modalState } = useModalStore();
  const { activeLead, activeTab } = useLeadsStore();
  const { showError } = useErrorToast();

  const initialValues = useMemo(() => ({
    Cliente__c: activeLead?.Cliente__c || null,
    Motivazione__c: activeLead?.Motivazione__c || "",
    FirstName: activeLead?.FirstName || "",
    LastName: activeLead?.LastName || "",
    Company: activeLead?.Company || "",
    Email: activeLead?.Email || "",
    Phone: activeLead?.Phone || "",
    City: activeLead?.City || "",
    Codice_Fiscale__c: activeLead?.Codice_Fiscale__c || "",
    Partita_Iva__c: activeLead?.Partita_Iva__c || "",
    Marca__c: activeLead?.Marca__c || "",
    Modello__c: activeLead?.Modello__c || "",
    LeadSource: activeLead?.LeadSource || null,
    Canale_del_lead__c: activeLead?.Canale_del_lead__c || null,
    Messaggio__c: activeLead?.Messaggio__c || "",
    Utm_sorgente__c: activeLead?.Utm_sorgente__c || "",
    Filiale_Dealer_Titolare__c: activeLead?.Filiale_Dealer_Titolare__c || "",
    LastModifiedDate: activeLead?.LastModifiedDate || "",
    Fonte_di_acquisizione__c: activeLead?.Fonte_di_acquisizione__c
  }), [activeLead]);

  const editLeadMutation = useMutation({
    mutationFn: (payload: LeadCreateRequestDTO) => apiClient.leadsControllerService.editLead(activeLead.Id, payload),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["leads_list"] });
      toaster.success(i18next.t('lead_edited_successfully'));
    },
    onError: (error) => {
      console.error("Error editing lead:", error);
      showError(error, i18next.t('error_editing_lead'));
    },
  });

  const canViewCallsLog = useMemo(() => {
    if (
      activeTab !== TabsEnum.NEW_LEADS
    ) {
      return true;
    }
  }, [modalState.mode, activeTab]);

  const canViewLeadsNotifications = useMemo(() => {
    if (
      activeTab !== TabsEnum.NEW_LEADS
    ) {
      return true;
    }
  }, [modalState.mode, activeTab]);

  return (
    <>
      <div className={`${activeTab === TabsEnum.NEW_LEADS}` ? 'd-flex mb-4' : ''}>
        <LeadCallsButtons />

        <div className="ms-auto">
          <LeadActionButtons />
        </div>
      </div >

      <LeadFormData
        initialValues={initialValues}
        submitFn={editLeadMutation}
        validationSchema={validationsLeadEditForm}
      />

      {canViewLeadsNotifications && (
        <>
          <hr />
          <LeadsNotifications />
        </>
      )}
      {canViewCallsLog && (
        <>
          <hr />
          <LeadCallsLog />
        </>
      )}

    </>
  );
}

export default LeadDetails;
